module.exports = __webpack_public_path__ + "img/locate-vending-machine-footer-SM06.65f6587c.png";